import { alpha } from '@mui/material/styles';

const withAlphas = (color) => {
  return {
    ...color,
    alpha4: alpha(color.main, 0.04),
    alpha8: alpha(color.main, 0.08),
    alpha12: alpha(color.main, 0.12),
    alpha30: alpha(color.main, 0.3),
    alpha50: alpha(color.main, 0.5),
  };
};

export const neutral = {
  50: '#f8f9fa',
  100: '#f3f4f6',
  200: '#e5e7eb',
  300: '#d2d6db',
  400: '#9da4ae',
  500: '#6c737f',
  600: '#4d5761',
  700: '#2f3746',
  800: '#1c2536',
  900: '#111927',
};

export const tertiary = withAlphas({
  lightest: '#f8f9fa',
  light: '#d2d6db',
  main: '#6c737f',
  dark: '#2f3746',
  darkest: '#1c2536',
  contrastText: '#ffffff',
});

export const success = withAlphas({
  lightest: '#f0fdf5',
  light: '#5fe89a',
  main: '#14a652',
  dark: '#108543',
  darkest: '#0a5229',
  contrastText: '#ffffff',
});

export const info = withAlphas({
  lightest: '#ecfdff',
  light: '#cff9fe',
  main: '#06aed4',
  dark: '#0e7090',
  darkest: '#164c63',
  contrastText: '#ffffff',
});

export const warning = withAlphas({
  lightest: '#fffaeb',
  light: '#fef0c7',
  main: '#f79009',
  dark: '#b54708',
  darkest: '#7a2e0e',
  contrastText: '#ffffff',
});

export const error = withAlphas({
  lightest: '#fef2f2',
  light: '#fecaca',
  main: '#e74c3c',
  dark: '#b91c1c',
  darkest: '#7f1d1d',
  contrastText: '#ffffff',
});

export const communicate = {
  default: '#2b3a48',
  comment: '#757575',
  info: '#547891',
  warning: '#ef7d00',
  critical: '#f44336',
  linkText: '#fff',
};

export const common = {
  white: '#ffffff',
  black: '#000000',
};

export const primary = {
  main: '#ef7d00',
  light: '#ffaa65',
  dark: '#b45100',
  hover: '#f87600',
  contrastText: '#ffffff',

  50: '#fff2e9',
  100: '#fed4b9',
  200: '#ffbd8e',
  300: '#fda667',
  400: '#f59244',
  500: '#ef7d00',
  600: '#de6900',
  700: '#b45100',
  800: '#8a3b00',
  900: '#632600',
};

export const secondary = {
  main: '#002e4f',
  light: '#33587a',
  dark: '#00172a',
  hover: '#003b66',
  contrastText: '#ffffff',

  50: '#e5eef3',
  100: '#b8cfde',
  200: '#8aafc8',
  300: '#5c8fb2',
  400: '#336f96',
  500: '#002e4f',
  600: '#002740',
  700: '#001f34',
  800: '#00172a',
  900: '#000d1a',
};

export const background = {
  50: '#fbfbfd',
  100: '#f1f2f7',
  200: '#dedfe3',
  300: '#cacbcf',
  400: '#aeaeb2',
  500: '#919194',
  600: '#747477',
  700: '#575759',
  800: '#3a3a3b',
  900: '#1d1d1e',
  primary: '#f1f2f7',
  secondary: '#002e4f',
};

export const text = {
  main: '#0a0a0a',
  light: '#52525b',
  dark: '#18181b',
  hover: '#27272a',
  contrastText: '#ffffff',

  50: '#f9f9f9',
  100: '#f2f2f2',
  200: '#e0e0e0',
  300: '#c8c8c8',
  400: '#a8a8a8',
  500: '#727272',
  600: '#525252',
  700: '#2c2c2c',
  800: '#1a1a1a',
  900: '#0a0a0a',
};

export const seenc = {
  light_green: '#a2c62c',
  dark_white: '#fffcfc',
  favorite: '#ffc107',
};

export const sales = {
  status: {
    pending: '#c1c1c1',
    success: '#2ecc71',
    error: '#e74c3c',
    orderCancelled: '#eeeeee',
    awaitingIntegration: '#2ecc71',
    awaitingInvoiceLabel: '#ef7d00',
    ready: '#ef7d00',
    buffered: '#a400e1',
  },
};

export const shipping = {
  status: {
    deadline: '#ef7d00',
    overdue: '#e74c3c',
    ontime: '#2ecc71',
  },
};

export const receiving = {
  status: {
    today: '#e74c3c',
    tomorrow: '#f79009',
    week: '#f1c40f',
    month: '#2ecc71',
  },
};

export const status = {
  pending_action: '#6c8ebf', //"#ef7d00",
  pending_system: '#ffa700',
  success: '#2ecc71',
  error: '#e74c3c',
  other: '#f1c40f',
};
